import React, {useEffect} from 'react'
import { useSelector } from 'react-redux'
import { ThemeProvider, createMuiTheme } from '@material-ui/core';
import Form from '../components/form'
import ClosedPage from '../components/closed_page.jsx'
import ThankYouPage from '../components/thank_you_page.jsx'
import QzPrinting from "../components/qz_printing"

// Just a container so it can be wrapped by material Ui theme
const RegistrationPageContent = () => {
  const registrationState = useSelector(state => state.registrationPageState?.state)

  const closed = useSelector(state => state.closed)
  const stop = useSelector(state => state.stop)
  const full = useSelector(state => state.full)
  const referrer_limit_reached = useSelector(state => state.referrer_limit_reached)

  const tabTitle = useSelector(state => state.tab_title).trim()

  useEffect(() => {
    if (tabTitle) {
      document.title = tabTitle
    }
  }, [tabTitle])

  /**
   * This maybe could be refactored even more and registrationState could be unified with stop/closed/full.
   * Also closed/full maybe should be unified?
   */
  if(registrationState === "thank_you" || stop) {
    return <ThankYouPage/>
  } else if (registrationState === "closed" || closed || full || referrer_limit_reached) {
    return <ClosedPage/>
  } else {
    return <Form/>
  }
}

const RegistrationPage = function() {
  const materialUiColor = useSelector(state => state.material_ui_color)
  const materialUiColorSecondary = useSelector(state => state.material_ui_color_secondary)

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: materialUiColor || "#E8374C",
      },
      secondary: {
        main: materialUiColorSecondary || '#008cff',
      },
    },
  });

  return <ThemeProvider theme={theme}>
    <RegistrationPageContent/>
    <QzPrinting/>
  </ThemeProvider>
}

export default RegistrationPage;
